import {hel_get_cookie} from '../logics/shared';

import {
  HEL_AUDIO_TYPE_SE,
  HEL_AUDIO_TYPE_SYSTEMSE,
  HEL_AUDIO_TYPE_VIDEO,
  HEL_AUDIO_TYPE_VOICE,
  HEL_AUDIO_TYPE_WORLD
} from './const';
import {
  setMixerMasterMute,
  setMixerMasterVolume,
  setMixerMuteAt,
  setMixerSettingAt
} from './dataOps';

export const hel_mixer_LoadCookie_Volume = () => {
  const VolumeWorld = hel_get_cookie('mixervolume_world');
  if (VolumeWorld !== undefined) {
    setMixerSettingAt(VolumeWorld as unknown as number, HEL_AUDIO_TYPE_WORLD);
  }

  const VolumeVoice = hel_get_cookie('mixervolume_voice');
  if (VolumeVoice !== undefined) {
    setMixerSettingAt(VolumeVoice as unknown as number, HEL_AUDIO_TYPE_VOICE);
  }

  const VolumeSE = hel_get_cookie('mixervolume_se');
  if (VolumeSE !== undefined) {
    setMixerSettingAt(VolumeSE as unknown as number, HEL_AUDIO_TYPE_SE);
  }

  const VolumeSystemSE = hel_get_cookie('mixervolume_systemse');
  if (VolumeSystemSE !== undefined) {
    setMixerSettingAt(VolumeSystemSE as unknown as number, HEL_AUDIO_TYPE_SYSTEMSE);
  }

  const VolumeVideo = hel_get_cookie('mixervolume_video');
  if (VolumeVideo !== undefined) {
    setMixerSettingAt(VolumeVideo as unknown as number, HEL_AUDIO_TYPE_VIDEO);
  }

  const VolumeMaster = hel_get_cookie('mixervolume_master');
  if (VolumeMaster !== undefined) {
    setMixerMasterVolume(VolumeMaster as unknown as number);
  }
};

export const hel_mixer_LoadCookie_Mute = () => {
  const MuteWorld = hel_get_cookie('mixermute_world');
  if (MuteWorld !== undefined) {
    setMixerMuteAt(MuteWorld as unknown as number, HEL_AUDIO_TYPE_WORLD);
  }

  const MuteVoice = hel_get_cookie('mixermute_voice');
  if (MuteVoice !== undefined) {
    setMixerMuteAt(MuteVoice as unknown as number, HEL_AUDIO_TYPE_VOICE);
  }

  const MuteSE = hel_get_cookie('mixermute_se');
  if (MuteSE !== undefined) {
    setMixerMuteAt(MuteSE as unknown as number, HEL_AUDIO_TYPE_SE);
  }

  const MuteSystemSE = hel_get_cookie('mixermute_systemse');
  if (MuteSystemSE !== undefined) {
    setMixerMuteAt(MuteSystemSE as unknown as number, HEL_AUDIO_TYPE_SYSTEMSE);
  }

  const MuteVideo = hel_get_cookie('mixermute_video');
  if (MuteVideo !== undefined) {
    setMixerMuteAt(MuteVideo as unknown as number, HEL_AUDIO_TYPE_VIDEO);
  }

  const MuteMaster = hel_get_cookie('mixermute_master');
  if (MuteMaster !== undefined) {
    setMixerMasterMute(MuteMaster as unknown as number);
  }
};
